<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="char"><span class="epub-sc">CHARACTERS</span></p>
<p class="ul">‘<span class="epub-sc">BLIND</span>’ <span class="epub-sc">BILLY BLUE</span>, a singer</p>
<p class="ul"><span class="epub-sc">ODYSSEUS</span>, the Greek general, King of Ithaca</p>
<p class="ul"><span class="epub-sc">ATHENA</span>, a goddess, also disguised as <span class="epub-sc">CAPTAIN MENTES, A SHEPHERD</span>, etc.</p>
<p class="fmh1"><span class="epub-i">Ithaca</span></p>
<p class="ul"><span class="epub-sc">PENELOPE</span>, wife of Odysseus</p>
<p class="ul"><span class="epub-sc">TELEMACHUS</span>, son of Odysseus</p>
<p class="ul"><span class="epub-sc">EURYCLEIA</span>, his old nurse</p>
<p class="ul"><span class="epub-sc">ANTINOUS</span>, a suitor to Penelope</p>
<p class="ul"><span class="epub-sc">EURYMACHUS, AMPHINOMUS, CTESIPPUS, LEODES</span> and <span class="epub-sc">POLYBUS</span>, suitors</p>
<p class="ul"><span class="epub-sc">MELANTHO</span>, a maid</p>
<p class="ul"><span class="epub-sc">EUMAEUS</span>, an old swineherd</p>
<p class="ul"><span class="epub-sc">ARNAEUS</span>, a lout</p>
<p class="fmh1"><span class="epub-i">Pylos</span></p>
<p class="ul"><span class="epub-sc">NESTOR</span>, King of Pylos</p>
<p class="fmh1"><span class="epub-i">Sparta</span></p>
<p class="ul"><span class="epub-sc">MENELAUS</span>, King of Sparta</p>
<p class="uls"><span class="epub-sc">HELEN</span>, his wife</p>
<p class="ul"><span class="epub-sc">PROTEUS</span>, the Old Man of the Sea</p>
<p class="fmh1"><span class="epub-i">The Ship</span></p>
<p class="ul"><span class="epub-sc">EURYLOCHUS</span>, Odysseus’ lieutenant</p>
<p class="ul"><span class="epub-sc">ELPENOR</span>, the helmsman</p>
<p class="ul"><span class="epub-sc">STRATIS, COSTA, STAVROS</span> and <span class="epub-sc">TASSO</span>, Odysseus’ crew</p>
<p class="fmh1"><span class="epub-i">Scheria</span></p>
<p class="ul"><span class="epub-sc">NAUSICAA</span>, a princess</p>
<p class="ul"><span class="epub-sc">ALCINOUS</span>, her father, King of the Phaeacians</p>
<p class="ul"><span class="epub-sc">ANEMONE</span> and <span class="epub-sc">CHLOE</span>, Phaeacian girls</p>
<p class="fmh1"><span class="epub-i">The Island of the Cyclops</span></p>
<p class="ul"><span class="epub-sc">CYCLOPS</span></p>
<p class="ul"><span class="epub-sc">A PHILOSOPHER</span></p>
<p class="ul"><span class="epub-sc">TWO PATROLMEN</span></p>
<p class="ul"><span class="epub-sc">RAM</span>, a manservant</p>
<p class="fmh1"><span class="epub-i">The Island of Calypso</span></p>
<p class="ul"><span class="epub-sc">CIRCE</span>, a witch</p>
<p class="ul"><span class="epub-sc">REVELLERS</span> and <span class="epub-sc">CELEBRANTS</span></p>
<p class="fmh1"><span class="epub-i">The Underworld</span></p>
<p class="ul"><span class="epub-sc">ANTICLEA</span>, Odysseus’ mother</p>
<p class="ul"><span class="epub-sc">TIRESIAS</span></p>
<p class="ul"><span class="epub-sc">AGAMEMNON, ACHILLES, THERSITES</span> and <span class="epub-sc">AJAX</span>, the ghosts of Troy</p>
<p class="ul"> </p>
<p class="ul">Suitors, Attendants, Maids, Sailors, Mermaids, Courtiers, Athletes, etc.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// characters.vue?01ad1a42